import { LogLevel } from './log-level';

export class LogEntry {
  readonly date: Date = new Date();

  constructor(readonly level: LogLevel, readonly message: string, readonly context?: any) {}

  getLevelName(): string {
    return LogLevel[this.level].toUpperCase();
  }
}
